import { BuildingContext, Incident } from "Context/BuildingProvider";
import { AuthContext } from "Firebase/AuthProvider";
import { Fragment, useContext, useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { useStyles } from "Theme/styles";
import update from "immutability-helper";
import {
  Box,
  Button,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { getPrettyDateString } from "helpers/FormatHelper";
import { ResolveIncidentMutationVariables } from "generated/graphql";
import { useMutation } from "@apollo/client";
import { ConfigForm, StandardModal } from "components/Layout";
import { RESOLVE_INCIDENT } from "lib/incidents";

interface IncidentsTableRow {
  title: string
  description: string
  endDateTime: string
  id: string
  startDateTime: string
}
interface IncidentsTableState {
  loading: boolean;
  incidentTableRows: IncidentsTableRow[];
  resolveIncidentModalOpen: boolean
  currentIncident: Incident|null
  resolutionText: string
}

const DEFAULT_STATE: IncidentsTableState = {
  loading: true,
  incidentTableRows: [],
  resolveIncidentModalOpen: false,
  currentIncident: null,
  resolutionText: ""
};

export default function IncidentsTable() {
  const [state, setState] = useState<IncidentsTableState>(DEFAULT_STATE);
  const { getDatabase } = useContext(AuthContext);
  const { incidentState, currentBuilding } = useContext(BuildingContext);
  const [resolveIncident] = useMutation<ResolveIncidentMutationVariables>(RESOLVE_INCIDENT)
  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    const tableRows: IncidentsTableRow[] = []
    console.log("🚀 ~ file: IncidentsTable.tsx ~ line 62 ~ IncidentsTable ~ incidentState", incidentState)
    for(const key in incidentState?.incidents){
      //@ts-ignore
      const incident = incidentState?.incidents[key]
      if(incident){
        console.log("🚀 ~ file: IncidentsTable.tsx ~ line 64 ~ useEffect ~ incident", incident)
        tableRows.push({
          id: incident.id,
          title: incident.title,
          description: incident.description,
          startDateTime: incident.startDateTime? getPrettyDateString(incident.startDateTime) : 'N/A',
          endDateTime: incident.endDateTime ? getPrettyDateString(incident.endDateTime): 'N/A',
        })
      }
    }
    // incidentState?.incidents?.forEach(incident=>{
    //   tableRows.push({
    //     id: incident.id,
    //     title: incident.title,
    //     description: incident.description,
    //     startDateTime: getPrettyDateString(incident.startDateTime),
    //     endDateTime: getPrettyDateString(incident.endDateTime),
    //   })
    // })
    setState(update(
      state, {
        loading: {$set: false},
        incidentTableRows: {$set: tableRows}
      }
    ))
  }, [incidentState]);

  const handleResolveIncident = async () => {
    if(state.currentIncident?.id){
      await resolveIncident({ variables: { id: state.currentIncident.id, Resolution: state.resolutionText}})
      if(!!getDatabase){
        const db = getDatabase();
        const incidentRef = db.ref(
          "buildings/" + currentBuilding?.Id + "/incidents/" + state.currentIncident.id
        );
        await incidentRef.remove();
      }
    }

    setState({ ...state, resolveIncidentModalOpen: false, currentIncident: null, resolutionText: ""})
  }

  const handleIncidentResolve = (id:string) => {
    //@ts-ignore
    const incident = incidentState?.incidents[id]
    if(incident){
      setState({
        ...state,
        resolveIncidentModalOpen: true,
        currentIncident: incident
      })
    }
  }
  const loading = state.loading;
  if (loading) {
    return <LinearProgress />;
  } else {
    return (
      <Fragment>
        <StandardModal open={state.resolveIncidentModalOpen}
          title="Resolve Incident"
          onCancel={() => {
            setState({
              ...state,
              resolveIncidentModalOpen: false,
              resolutionText: ""
            });
          }}
          onSubmit={handleResolveIncident}>
          <ConfigForm inputs={[{
            title: "Resolution Action",
          type: "text",
            onChange: (event: any) => {
                  setState({ ...state, resolutionText: event.target.value });
            },
          xs: 12,
          sm: 12,
          id: "resolutionText",
            value: state.resolutionText,
    }]}/>
          </StandardModal>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Typography color="textPrimary" variant="h4">
                Incidents
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Start Time</TableCell>
                    <TableCell>End Time</TableCell>
                    <TableCell>Resolve</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {state.incidentTableRows.map((tableRow: IncidentsTableRow) => (
                    <TableRow hover key={tableRow.id}>
                      <TableCell component="th" scope="row">
                        {tableRow.title}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.description}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.startDateTime}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.endDateTime}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Button onClick={()=>{handleIncidentResolve(tableRow.id)}}>Resolve</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
        </Paper>
      </Fragment>
    );
  }
}
